// ConfirmationModal.js
import React from 'react';
import { Modal, Button, Text } from '@mantine/core';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => (
  <Modal opened={isOpen} onClose={onClose} title={title} centered>
    <Text>{message}</Text>
    <div className="mt-4 flex justify-end space-x-2">
      <Button variant="outline" color="gray" onClick={onClose}>
        Cancel
      </Button>
      <Button color="red" onClick={onConfirm}>
        Confirm
      </Button>
    </div>
  </Modal>
);

export default ConfirmationModal;
